import React, { forwardRef } from 'react';
import { classNames } from '../../utils/format';

const Textarea = forwardRef(function Textarea({ className, invalid, rows = 3, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={classNames('form-control form-textarea', invalid && 'is-invalid', className)}
      {...rest}
    />
  );
});

export default Textarea;
